//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "productListEffect",
  data() {
    return {
      viewMoreLinkArr: [],
      page: 1,
      limit: 1,
      catagoryId: 1,
      isNext: true,
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    ...mapGetters("productList", ["productListEffectData", "productListEffectCategroyInfo"]),
    // 计算属性
    //类目信息
    listCategoryData() {
      let obj = JSON.parse(JSON.stringify(this.productListEffectCategroyInfo));
      return obj;
    },
    //产品信息
    listCategoryProductData() {
      let obj = JSON.parse(JSON.stringify(this.productListEffectData));
      return obj;
    },
    //数据处理
    listInfoData() {
      let that = this;
      let obj = this.listCategoryProductData;
      obj = obj.map((item, index) => {
        that.viewMoreLinkArr.push(item?.data?.list[0]?.urlPath || "");
        return {
          categroyInfo: this.listCategoryData.list[index],
          productInfo: item?.data?.list,

          swiperOptions: {
            paginationClickable: true,
            preventClicks: true,
            loop: false,
            autoplayDisableOnInteraction: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: "4%",
            navigation: {
              nextEl: `.effect-swiper${index} .effect-button-next`,
              prevEl: `.effect-swiper${index} .effect-button-prev`,
            },
            on: {
              slideChange() {
                let nowItem = item?.data?.list[this.realIndex];
                // obj[index].viewMoreLink = nowItem.urlPath;
                that.viewMoreLinkArr[index] = nowItem.urlPath;
              },
            },
            observer: true,
            observeParents: true,
          },
        };
      });
      return obj;
    },
  },
  components: {
    // 组件的引用
  },
  methods: {
    ...mapMutations("productList", ["setProductListEffectData", "setProductListEffectCategroyInfo"]),
    // 方法

    //获取下一页
    async getNextPageData() {
      let nextCategoryListRes = await this.$categoriesList({
        page: this.page,
        limit: this.limit,
        id: this.catagoryId,
      });
      if (nextCategoryListRes.code == 200000) {
        //将子类目list信息 处理 为了展示标题
        nextCategoryListRes.data.list.map((item) => {
          this.listCategoryData.list.push(item);
        });
        this.setProductListEffectCategroyInfo(this.listCategoryData);
        //循环请求 产品列表信息
        let allPromise = [];
        for (let index = 0; index < nextCategoryListRes.data.list.length; index++) {
          const element = nextCategoryListRes.data.list[index];
          allPromise.push(
            await this.$productsOptionList({
              page: 1,
              limit: 20,
              category_id: element.id,
              is_attributes: 1,
              is_options: 0,
              attributes_select: ["use_before_image", "use_after_image", "use_before_desc", "use_after_desc"],
            })
          );
        }
        let listCategoryNextData = await Promise.all([...allPromise]);
        //产品列表信息 push到 渲染数据中
        listCategoryNextData.map((item) => {
          this.listCategoryProductData.push(item);
        });
        console.log("222", this.listCategoryProductData);
        this.setProductListEffectData(this.listCategoryProductData);
      }
    },
  },
  mounted() {
    // 页面进入时加载内容
    /**
     * @Author: liguohua 2490322461@qq.com
     * @Date: 2023-04-20 10:33:24
     * @LastAuthor: liguohua 2490322461@qq.com
     * @description: 处理思路跟._vue文件中的一致 先请求当前类目下的子类目列表；然后根据返回的子类目信息 去循环调用产品列表接口 然后渲染
     * @return {*}
     * @Description: Do not Description
     */

    this.page = this.listCategoryData.paginate.currentPage;
    this.limit = this.listCategoryData.paginate.perPage;
    this.catagoryId = this.listCategoryData.category.id;

    this.tool.reachBottomEle(".productListEffect-bottom", () => {
      console.log(this.page * this.limit >= this.listCategoryData.paginate.total);
      if (this.page * this.limit >= this.listCategoryData.paginate.total) {
        return;
      }
      if (this.isNext) {
        this.page = this.page + 1;
        this.getNextPageData();
      }
    });
    console.log(this.listCategoryData, "数据呢");
  },
  watch: {
    // 监测变化
  },
};
